import i18n from "@/i18n"
import { RouteRecordRaw } from "vue-router"

const { t } = i18n.global

export const estatisticasRotas = (): RouteRecordRaw[] => [
  {
    path: "/estatisticas",
    name: "Estatisticas",
    meta: {
      titulo: t("tituloDaRotaDeEstatisticas"),
      regras: ["auth", "cancelador"],
      permissoes: [],
    },
    component: () =>
      import(
        /* webpackChunkName: "Estatisticas" */
        "@/paginas/Estatisticas/Estatisticas.vue"
      ),
  },
]
